import { Component, OnInit, Input } from '@angular/core';
import { DATA_PER_PAGE } from '@root/app.constant';
import { CatalogService } from '@catalog/catalog.service';

@Component({
  selector: 'app-investment-approach',
  templateUrl: './investment-approach.component.html',
  styleUrls: ['./investment-approach.component.scss']
})
export class InvestmentApproachComponent implements OnInit {

  @Input() data: any[];

  pageSize: number = DATA_PER_PAGE;

  constructor(private catalogService: CatalogService) { }

  ngOnInit() {
    this.readAllKeyFeatures();
  }

  private readAllKeyFeatures() {
    this.catalogService.readAllInvestmentApproach().subscribe(
      (respose) => {
        this.data = respose.data.list;
      },
      (error) => {}
    );
  }

  viewFile = (path) => {
    window.open(path, '_blank');
  };

}
